export default "__VITE_ASSET__2b20661d__"